// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pageRoot[data-v-22552da6]\n{\n\tmargin: 8px;\n}\n.loading[data-v-22552da6]\n{\n\tmargin-top: 80px;\n\ttext-align: center;\n}\n.error[data-v-22552da6]\n{\n\tcolor: #FF0000;\n\tfont-weight: bold;\n}\n.buttonRow[data-v-22552da6]\n{\n\tmargin-top: 30px;\n\tborder-top: 1px solid #AAAAAA;\n\tpadding-top: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
